import { render, staticRenderFns } from "./selectPerson.vue?vue&type=template&id=fdf60d46&scoped=true&"
import script from "./selectPerson.vue?vue&type=script&lang=js&"
export * from "./selectPerson.vue?vue&type=script&lang=js&"
import style0 from "./selectPerson.vue?vue&type=style&index=0&id=fdf60d46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdf60d46",
  null
  
)

export default component.exports